import { formatNumber } from './number';

export const getRepoFacts = (
  repoData: CustomTypes.RepoData | null | undefined,
  max = 4,
  icon = true,
): CustomTypes.Facts => {
  if (
    !repoData ||
    repoData.stars +
      repoData.forks +
      repoData.watchers +
      repoData.contributors ===
      0
  ) {
    return [];
  }

  const facts = [
    {
      count: formatNumber(repoData.stars),
      description: `star${repoData.stars === 1 ? '' : 's'}`,
      icon: icon ? 'star' : null,
    },
    {
      count: formatNumber(repoData.forks),
      description: `fork${repoData.forks === 1 ? '' : 's'}`,
      icon: icon ? 'fork' : null,
    },
    {
      count: formatNumber(repoData.watchers),
      description: 'watching',
      icon: icon ? 'watching' : null,
    },
    {
      count: formatNumber(repoData.contributors),
      description: `contributor${repoData.contributors === 1 ? '' : 's'}`,
      icon: icon ? 'contributors' : null,
    },
  ];

  return facts.slice(0, max);
};
